module.exports = __webpack_public_path__ + "img/norway-external-causes-male.da61d634.png";